import styled from "styled-components";
import { Input } from "./Input";
import { FormGroup } from "./FormGroup";
import { FormLabel } from "./FormLabel";
import { spacing } from "@styling/sizing";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";

const MoneyInputGroup = styled.div`
  display: flex;
  gap: ${spacing.x2}px;
  align-items: flex-end;
`;

const MoneyAmountInput = styled(Input)`
  flex: 1;
`;

const MoneyCurrencyDisplay = styled.div`
  padding: 13px ${spacing.x2}px;
  background-color: ${colors.backgroundDark};
  border: 1px solid ${colors.border};
  border-radius: 4px;
  font-size: ${fontSizes.regular}px;
  color: ${colors.text};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface MoneyInputProps {
  label: string;
  amount: number;
  currency: string;
  onAmountChange: (amount: number) => void;
  onAmountBlur?: () => void;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

export const MoneyInput = ({
  label,
  amount,
  currency,
  onAmountChange,
  onAmountBlur,
  required,
  placeholder = "Amount",
  disabled = false,
}: MoneyInputProps) => {
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <MoneyInputGroup>
        <MoneyAmountInput
          type="number"
          step="0.01"
          min="0"
          value={amount}
          onChange={(e) => onAmountChange(parseFloat(e.target.value))}
          onBlur={onAmountBlur}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
        />
        <MoneyCurrencyDisplay>{currency}</MoneyCurrencyDisplay>
      </MoneyInputGroup>
    </FormGroup>
  );
};
